import React from 'react';
import logo from './logo.svg';
import bg from './ZenMLB.jpg'
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <img src={bg}  alt="bg" />
        <p>
          Good things are brewing, Check back later!
        </p>
      </header>
    </div>
  );
}

export default App;
